import { render, staticRenderFns } from "./StudentRelationsArAccountsList.vue?vue&type=template&id=b8a015d8&scoped=true&"
import script from "./StudentRelationsArAccountsList.vue?vue&type=script&lang=js&"
export * from "./StudentRelationsArAccountsList.vue?vue&type=script&lang=js&"
import style0 from "./StudentRelationsArAccountsList.vue?vue&type=style&index=0&id=b8a015d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a015d8",
  null
  
)

export default component.exports